import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import { usePopup } from "react-hook-popup";
import { useState } from "react";

import SimplePopupDialog from "../../../components/SimplePopupDialog";
import InfoBlock from "../components/InfoBlock";
import useEditMember from "../../../hooks/useEditMember";
import MemberInfoPanel from "../../../components/MemberInfoPanel";
import ProfileToggleBarBase from "./ProfileToggleBarBase";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import useCheckPermissionHook from "../../../hooks/useCheckPermissionHook";
const useStyles = makeStyles((theme) => {
  return {
    allContainer: {
      position: "relative",
      width: "100%",
      height: "100%",
      top: 0,
      bottom: 0,
    },
    breadcrumbs: {
      margin: 0,
    },
    gridContainer: {
      position: "absolute",
      top: 0,
      bottom: 0,
    },
    title: {
      marginTop: 20,
      marginBottom: 10,
    },
    leftPanel: {
      width: "100%",
      height: "100%",
      paddingTop: 20,
      paddingLeft: 20,
      paddingRight: 20,
      boxSizing: "border-box",
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
    },
    rightPanel: {
      backgroundColor: theme.white,
    },
  };
});

/**
 *
 * @param {id, tabs}
 * id id of the member
 * tabs tabs information
 * [
 * {title: "Work", blocks},
 *  {title: "Educations", blocks}, ==> block: {title: "การงาน", isArray: true, groupKey: "socials", datas}
 * ]
 * @returns
 */
const MemberProfileBaseView = ({ title, ci, member, tabs }) => {
  const classes = useStyles();
  const { loading, allow } = useCheckPermissionHook({
    code: "Page.Merchant.Customer_Insight",
    write: true,
  });

  const [showPopup] = usePopup("success", ({ message, handleClose }) => (
    <SimplePopupDialog
      message={message?.message}
      title={message?.title}
      handleClose={handleClose}
      onConfirm={message?.onConfirm}
    />
  ));

  const [showAlert] = usePopup("alert", ({ message, handleClose }) => (
    <SimplePopupDialog
      message={message?.message}
      title={message?.title}
      handleClose={handleClose}
      error={true}
    />
  ));
  const [selectedTab, setSelectedTab] = useState(tabs[0].title);

  const { editMember } = useEditMember();

  const handleOnSave = async (data) => {
    try {
      const result = await editMember({
        id: ci.id,
        version: ci.__v,
        ...data,
      });
      if (result.error) {
        return showAlert({ title: "Error", message: result.message });
      }
      showPopup({
        title: "Success",
        message: "Update successfully",
        onConfirm: () => {
          window.location.reload();
        },
      });
      //return window.location.reload();
    } catch (error) {
      alert("Failed ");
    }
  };
  if (loading) return null;
  return (
    <Box className={classes.allContainer}>
      <Grid className={classes.gridContainer} container>
        <Grid item xs={8} className={classes.leftPanel}>
          <SfBreadcrumbs
            path="Customer Insight/Member/Profile"
            className={classes.breadcrumbs}
            lower
          />
          <Title title={title} />
          {tabs?.length > 1 ? (
            <ProfileToggleBarBase
              tabs={tabs}
              value={selectedTab}
              onChange={(value) => setSelectedTab(value)}
            />
          ) : null}

          {tabs.map((tab) => {
            if (tab.title === selectedTab) {
              return (
                <>
                  {tab.blocks.map((block) => {
                    return (
                      <InfoBlock
                        allowWrite={allow}
                        title={block.title}
                        contents={block.datas.filter((a) => a)}
                        onSave={(data) => handleOnSave(data)}
                        isArray={block.isArray}
                        groupKey={block.groupKey}
                        noEdit={block.noEdit}
                        address={block.address}
                      />
                    );
                  })}
                </>
              );
            } else return null;
          })}
        </Grid>
        <Grid item xs={4} className={classes.rightPanel}>
          <MemberInfoPanel id={member.id} />
        </Grid>
      </Grid>
    </Box>
  );
};

const Title = ({ title }) => {
  const classes = useStyles();
  return (
    <Typography align="center" variant="h4" className={classes.title}>
      {title}
    </Typography>
  );
};

export default MemberProfileBaseView;
